import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import CalendarHeader from './CalendarHeader';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import ReduxCalender from '../../../../store/actionreducers/calender';
import EventDialog from './EventDialog';
import {withRouter} from 'react-router-dom';

import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import ReduxGlobal from "../../../../store/actionreducers/globalView";

moment.locale('zh-tw');
const localizer = BigCalendar.momentLocalizer(moment);

// let allViews = Object.keys(BigCalendar.Views).map(k => BigCalendar.Views[k]);

const styles = theme => ({
    root: {
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        flex: 1,
        '& .rbc-header': {
            padding: '12px 6px',
            fontWeight: 600,
            fontSize: 14
        },
        '& .rbc-label': {
            padding: '8px 6px'
        },
        '& .rbc-today': {
            backgroundColor: 'transparent'
        },
        '& .rbc-header.rbc-today, & .rbc-month-view .rbc-day-bg.rbc-today': {
            borderBottom: '2px solid ' + theme.palette.secondary.main + '!important'
        },
        '& .rbc-month-view, & .rbc-time-view, & .rbc-agenda-view': {
            padding: 24,
            [theme.breakpoints.down('sm')]: {
                padding: 16
            },
            ...theme.mixins.border(0)
        },
        '& .rbc-agenda-view table': {
            ...theme.mixins.border(1),
            '& thead > tr > th': {
                ...theme.mixins.borderBottom(0)
            },
            '& tbody > tr > td': {
                padding: '12px 6px',
                '& + td': {
                    ...theme.mixins.borderLeft(1)
                }
            }
        },
        '& .rbc-time-view': {
            '& .rbc-time-header': {
                ...theme.mixins.border(1)
            },
            '& .rbc-time-content': {
                flex: '0 1 auto',
                ...theme.mixins.border(1)
            }
        },
        '& .rbc-month-view': {
            '& > .rbc-row': {
                ...theme.mixins.border(1)
            },
            '& .rbc-month-row': {
                ...theme.mixins.border(1),
                borderWidth: '0 1px 1px 1px!important',
                minHeight: 128
            },
            '& .rbc-header + .rbc-header': {
                ...theme.mixins.borderLeft(1)
            },
            '& .rbc-header': {
                ...theme.mixins.borderBottom(0)
            },
            '& .rbc-day-bg + .rbc-day-bg': {
                ...theme.mixins.borderLeft(1)
            }
        },
        '& .rbc-day-slot .rbc-time-slot': {
            ...theme.mixins.borderTop(1),
            opacity: 0.5
        },
        '& .rbc-time-header > .rbc-row > * + *': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-time-content > * + * > *': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-day-bg + .rbc-day-bg': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-time-header > .rbc-row:first-child': {
            ...theme.mixins.borderBottom(1)
        },
        '& .rbc-timeslot-group': {
            minHeight: 64,
            ...theme.mixins.borderBottom(1)
        },
        '& .rbc-date-cell': {
            padding: 8,
            fontSize: 16,
            fontWeight: 400,
            opacity: .5,
            '& > a': {
                color: 'inherit'
            }
        },
        '& .rbc-event': {
            borderRadius: 4,
            padding: '4px 8px',
            backgroundColor: theme.palette.primary.dark,
            color: theme.palette.primary.contrastText,
            boxShadow: theme.shadows[0],
            transitionProperty: 'box-shadow',
            transitionDuration: theme.transitions.duration.short,
            transitionTimingFunction: theme.transitions.easing.easeInOut,
            position: 'relative',
            '&:hover': {
                boxShadow: theme.shadows[2]
            }
        },
        '& .rbc-row-segment': {
            padding: '0 4px 4px 4px'
        },
        '& .rbc-off-range-bg': {
            backgroundColor: theme.palette.type === 'light' ? 'rgba(0,0,0,0.03)' : 'rgba(0,0,0,0.16)'
        },
        '& .rbc-show-more': {
            color: theme.palette.secondary.main,
            background: 'transparent'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event': {
            position: 'static'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:first-child': {
            left: 0,
            top: 0,
            bottom: 0,
            height: 'auto'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:last-child': {
            right: 0,
            top: 0,
            bottom: 0,
            height: 'auto'
        }
    },
    addButton: {
        position: 'absolute',
        right: 12,
        top: 172,
        zIndex: 99
    }
});

const weekDayMap = {
    Sun: '日',
    Mon: '一',
    Tue: '二',
    Wed: '三',
    Thu: '四',
    Fri: '五',
    Sat: '六',
};

let monthCustomHeader = ({label}) => (
    <div>{weekDayMap[label]}</div>
);

/*let weekCustomHeader = ({label}) => {
    const leftStr = label.substring(0, label.length - 3);
    const rightStr = label.substr(label.length - 3, 3);
    return (<div>{leftStr + ' ' + weekDayMap[rightStr]}</div>);
};*/

class CalendarApp extends Component {

    _getViewStartDate(date, view) {

        if (view === 'month') return moment(date).startOf('month').toDate();
        else if (view === 'week' || view === 'work_week') return moment(date).startOf('week').toDate();
        else if (view === 'day') return date;
    }

    _getViewEndDate(date, view) {

        if (view === 'month') return moment(date).endOf('month').toDate();
        else if (view === 'week' || view === 'work_week') return moment(date).endOf('week').toDate();
        else if (view === 'day') return date;
    }

    async componentDidMount() {
        await this.props.getMonthlyWorkEvents({year: new Date().getFullYear(), month: new Date().getMonth()+1});
    }

    async handleNavigate(date, view, action) {
        let year = moment(date).year()
        let month = moment(date).month()+1  // jan=0, dec=11
        await this.props.getMonthlyWorkEvents({year, month});


        //
        // const {getWorkEvents, openLoadingMask, closeLoadingMask, preStartDate, preEndDate} = this.props;
        //
        // const startDate = moment.min([moment(date).startOf('month'), moment(date).startOf('week')]).toDate();
        // const endDate = moment.max([moment(date).endOf('month'), moment(date).endOf('week')]).toDate();
        //
        // const viewStartDate = this._getViewStartDate(date, view);
        // const viewEndDate = this._getViewEndDate(date, view);
        //
        // console.log('action =', action);
        // console.log('preStartDate =', preStartDate);
        // console.log('preEndDate=', preEndDate);
        // console.log('viewStartDate=', viewStartDate);
        // console.log('viewEndDate=', viewEndDate);
        // console.log('preStartDate >= viewStartDate=', preStartDate <= viewStartDate);
        // console.log('preEndDate >= viewEndDate=', preEndDate >= viewEndDate);
        //
        // if (preStartDate && preEndDate) {
        //     if (action === navigate.PREVIOUS && preStartDate <= viewStartDate) return;
        //     else if (action === navigate.NEXT && preEndDate >= viewEndDate) return;
        // }
        //
        //
        // openLoadingMask();
        //
        // // 不論 週 . 月 . 日 , 都先將資料抓好
        // await getWorkEvents({startDate, endDate});

        /*

        if (view === 'month') {
            // TODO 取上個月的資料

            // const lastMonth = moment(date).subtract(1, 'month');

            const startDate = moment(date).startOf('month').toDate();
            const endDate = moment(date).endOf('month').toDate();

            // const dateArray = dateUtil.getDailyDateArray({startDate, endDate});

            await getWorkEvents({startDate, endDate});

        } else if (view === 'week') {
            // TODO 取上周的資料

            // const lastWeek = moment(date).subtract(7, 'days');

            const startDate = moment(date).startOf('week').toDate();
            const endDate = moment(date).endOf('week').toDate();

            // const dateArray = dateUtil.getDailyDateArray({startDate, endDate});

            await getWorkEvents({startDate, endDate});

        } else if (view === 'work_week') {

            // TODO 取上周的資料

            // const lastWeek = moment(date).subtract(7, 'days');

            const startDate = moment(date).startOf('week').isoWeekday(1).toDate();
            const endDate = moment(date).endOf('week').isoWeekday(5).toDate();

            // const dateArray = dateUtil.getDailyDateArray({startDate, endDate});

            await getWorkEvents({startDate, endDate});

        } else if (view === 'day') {

            // const lastDay = moment(date).subtract(1, 'days');

            // TODO 取昨天的資料
            await getWorkEvents({startDate: date, endDate: date});
            // await getWorkEvents({startDate: lastDay, endDate: lastDay});


        }

        */

        // closeLoadingMask();

    }

    render() {
        const {classes, events} = this.props;

        return (
            <div className={classes.root}>
                <BigCalendar
                    className="flex flex-1"
                    selectable
                    localizer={localizer}
                    events={events}
                    resizable
                    defaultView={BigCalendar.Views.MONTH}
                    defaultDate={new Date()}
                    startAccessor="start"
                    endAccessor="end"
                    views={['month']}
                    step={60 * 4}
                    timeslots={1}
                    showMultiDayTimes
                    components={{
                        toolbar: CalendarHeader,
                        month: {header: monthCustomHeader},
                    }}
                    onNavigate={this.handleNavigate.bind(this)}
                    onSelectEvent={event => {
                        let date = moment(event.start).format('YYYY-MM-DD')
                        try {
                            this.props.history.push({
                                pathname: `/apps/calendar/${date}`,
                                state: {redirectUrl: this.props.location.pathname}
                            });
                        } catch (e) {
                            console.warn('you got an error = ', e);
                        }
                    }}
                    onSelectSlot={ slotInfo => {
                        let date = moment(slotInfo.start).format('YYYY-MM-DD')
                        try {
                            this.props.history.push({
                                pathname: `/apps/calendar/${date}`,
                                state: {redirectUrl: this.props.location.pathname}
                            });
                        } catch (e) {
                            console.warn('you got an error = ', e);
                        }
                    }}
                    eventPropGetter={(event) => {
                            let newStyle = {
                                backgroundColor: "red",
                                color: 'white',
                                borderRadius: "5px",
                                height: 25,
                            };

                            switch (event.level) {
                                case 1:
                                    newStyle.backgroundColor = '#249f8b';
                                    break;
                                case 2:
                                    newStyle.backgroundColor = '#3d6ef6';
                                    break;
                                default:
                                    newStyle.backgroundColor = '#ff7d7d';
                                    break;
                            }

                            return {
                                className: "",
                                style: newStyle
                            };
                        }
                    }
                />
                <EventDialog/>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getEvents: ReduxCalender.ActionCreator.getEvents,
        getMonthlyWorkEvents: ReduxCalender.ActionCreator.getMonthlyWorkEvents,
        openNewEventDialog: ReduxCalender.ActionCreator.openNewEventDialog,
        openEditEventDialog: ReduxCalender.ActionCreator.openEditEventDialog,
        getWorkEvents: ReduxCalender.ActionCreator.getWorkEvents,
        updateEvent: ReduxCalender.ActionCreator.updateEvent,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
    }, dispatch);
}

function mapStateToProps({calendarApp}) {
    return {
        events: calendarApp.entities,
        preStartDate: calendarApp.startDate,
        preEndDate: calendarApp.endDate
    }
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(CalendarApp)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/calendar/CalendarApp.js